import SaveDraftModal from 'apps/web_forms/components/SaveDraftModal';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  deleteDraft as deleteDraftApi,
  reassignDraft as reassignDraftCall,
  getDraftXMLString,
  saveNewDraft,
} from 'apps/web_forms/api/api';

import { fetchDraftList, setModal } from 'apps/web_forms/slices/appSlice';
import {
  APP_ROUTES,
  ModalTypes,
  modalMessages,
} from 'apps/web_forms/utils/constants';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

export const CopyDraftModal = ({ resetSelectedModal, extraProps }) => {
  const { draftId: draftIdToCopy } = extraProps;
  const { draftList } = useGlobalSelector();
  const drafts = draftList.data || [];

  const [draftDescriptionInputValue, setDraftDescriptionInputValue] =
    useState('');

  const dispatch = useDispatch();
  const history = useHistory();

  const copyDraft = async () => {
    try {
      const draftToCopy = await getDraftXMLString(draftIdToCopy);
      const draftToCopyMetadata = drafts.find(
        (draft) => draft.identifier === draftIdToCopy
      );
      const resourceVersions = draftToCopyMetadata.resourceVersions;
      const response = await saveNewDraft(
        draftToCopy,
        draftDescriptionInputValue,
        resourceVersions
      );
      if (response.status >= 200 && response.status < 300) {
        dispatch(
          setModal({
            type: ModalTypes.COPY_DRAFT_SUCCESS_MODAL,
            extraProps: {},
          })
        );
        dispatch(fetchDraftList());
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      history.push(APP_ROUTES.getErrorPageByCode(500));
    }
  };

  return (
    <SaveDraftModal
      draftDescriptionInputValue={draftDescriptionInputValue}
      setDraftDescriptionInputValue={setDraftDescriptionInputValue}
      draftModalOpen={true}
      setDraftModalOpen={resetSelectedModal}
      mainMessage={modalMessages.copyDraft.main}
      helpTip={modalMessages.copyDraft.tip}
      saveButtonText='Copy'
      onSave={copyDraft}
    />
  );
};
